// eslint-disable-next-line no-unused-vars
import React from 'react'
import { connect } from 'react-redux'
import { actions } from './'
import WishlistPage from './WishlistPage'
import { push } from 'connected-react-router'
import { actions as cartActions } from 'features/Cart/index'

const mapStateToProps = ({ wishlist, cart, participant }) => {
  if (wishlist) {
    return {
      wishlist: wishlist,
      email: cart.customer ? cart.customer.email : participant.email.value
    }
  } else return { wishlist: {} }
}

const mapDispatchToProps = dispatch => ({
  loadWishList: () => dispatch(actions.loadWishList()),
  selectWishlist: (skuId, selected) =>
    dispatch(actions.selectWishlist(skuId, selected)),
  selectAllWishlist: selected => dispatch(actions.selectAllWishlist(selected)),
  addListToCart: list => dispatch(actions.addListToCart(list)),
  redirectCart: () => dispatch(push('/cart')),
  addItemToCart: data => dispatch(cartActions.addItem(data))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WishlistPage)



// WEBPACK FOOTER //
// ./src/Participant/Wishlist/WishlistPage/WishlistPageContainer.js